module.exports = __webpack_public_path__ + "static/media/appt_reminder_banner.681a1844.svg";